import { Component, type ReactNode } from "react";
import { reportClientError } from "@/lib/monitoring";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export default class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error): void {
    reportClientError(error, "error-boundary");
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-black flex items-center justify-center px-6">
          <div className="text-center max-w-md">
            <h1 className="text-4xl font-bold text-white mb-4 font-heading">
              Something went wrong
            </h1>
            <p className="text-gray-400 mb-8">
              We're sorry, an unexpected error occurred. Please try refreshing the page.
            </p>
            <button
              onClick={() => {
                this.setState({ hasError: false });
                window.location.assign("/");
              }}
              className="bg-white text-black px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-200 transition-colors"
            >
              Return to Home
            </button>
            <div className="mt-6">
              <a
                href="tel:+642102984443"
                className="text-gray-500 hover:text-white transition-colors text-sm"
              >
                Or call us: 021 029 84443
              </a>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
